<div
  class="surface-ground justify-content-center flex min-h-screen overflow-hidden pt-1">
  <div class="flex flex-column w-full">
    <ls-toast-atom />
    <ls-card-atom [title]="title">
      <div>
        <p-table
          #dt
          [globalFilterFields]="['title', 'description']"
          [columns]="cols"
          [value]="sections"
          responsiveLayout="stack"
          [breakpoint]="'960px'"
          [exportHeader]="'customExportHeader'"
          [tableStyle]="{ 'min-width': '60rem' }"
          (onRowReorder)="onRowReorder($event)"
          [loading]="isLoading()"
          [rowTrackBy]="identify"
          [styleClass]="'p-datatable-sm'">
          <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between pb-2">
              <ls-button-icon-atom
                label="Nuevo"
                icon="ph ph-plus"
                severity="secondary"
                (onClick)="editSection(null)"></ls-button-icon-atom>

              <div class="flex gap-2">
                <p-dropdown
                  [options]="languages"
                  [(ngModel)]="selectedCountry"
                  optionLabel="name"
                  placeholder="Idioma"
                  (onChange)="changeLang($event)">
                  <ng-template pTemplate="selectedItem">
                    <div
                      class="flex align-items-center gap-2"
                      *ngIf="selectedCountry">
                      <img
                        alt="flag"
                        src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                        [class]="selectedCountry.lang | flagLanguage"
                        style="width: 18px" />
                      <div>{{ selectedCountry.name }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-country pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <img
                        alt="flag"
                        src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                        [class]="country.lang | flagLanguage"
                        style="width: 18px" />
                      <div>{{ country.name }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>

                <ls-input-atom
                  placeholder="Buscar..."
                  [showIcon]="true"
                  icon="ph ph-magnifying-glass"
                  (onInput)="onGlobalFilter(dt, $event)" />
                <ls-button-icon-atom
                  label="Export"
                  icon="pi pi-external-link"
                  severity="primary"
                  (onClick)="exportToExcel(dt)"></ls-button-icon-atom>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th scope="reorder" style="width: 2rem"></th>
              <th scope="master" style="width: 2rem"></th>
              <th
                scope="column"
                *ngFor="let col of columns"
                class="col-{{ col.field }}">
                {{ col.header }}
              </th>
              <th scope="column" style="width: 3rem"></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-rowData
            let-columns="columns"
            let-index="rowIndex">
            <tr *ngIf="!isLoading()" [pReorderableRow]="index">
              <td>
                <span class="pi pi-bars" pReorderableRowHandle></span>
              </td>
              <td>
                <span *ngIf="selectedCountry.lang !== rowData.lang">
                  <img
                    alt="flag"
                    src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                    [class]="rowData.lang | flagLanguage"
                    style="width: 18px" />
                </span>
              </td>
              <td *ngFor="let col of columns">
                @if(col.field === 'title') {
                <span innerHTML="{{ rowData[col.field] }}"></span>
                <span
                  class="block font-light text-xs mt-2"
                  *ngIf="rowData['date_ini']"
                  >{{ rowData['date_ini'] | date : 'mediumDate' }} -
                  {{ rowData['date_end'] | date : 'mediumDate' }}</span
                >
                } @else if(col.field === 'active') {
                <ls-checkbox-atom
                  [disabled]="!(selectedCountry.lang | infoLanguage)?.master"
                  [(ngModel)]="rowData[col.field]"
                  (change)="changeActive(rowData)" />
                } @else if (col.field === 'image'){ @if(rowData[col.field] !==
                null) {
                <img
                  alt="seccion"
                  class="image-section"
                  width="100px"
                  src="{{ rowData[col.field] }}"
                  onError="this.onerror = null; this.src='/assets/not-available.jpeg';" />
                } } @else {
                <span
                  innerHTML="{{ rowData[col.field] }}"
                  class="ellipsis-block"></span>
                }
              </td>
              <td>
                <div class="flex gap-2 justify-content-end">
                  <ls-button-icon-atom
                    severity="secondary"
                    size="small"
                    [rounded]="true"
                    (onClick)="editSection(rowData.id)">
                    <span class="material-icons">edit</span>
                  </ls-button-icon-atom>

                  <ls-button-icon-atom
                    [rounded]="true"
                    severity="danger"
                    size="small"
                    (onClick)="deleteSection(rowData.id)">
                    <span class="material-icons">delete</span>
                  </ls-button-icon-atom>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="loadingbody" let-columns="columns">
            <ls-progress-spinner-atom></ls-progress-spinner-atom>
          </ng-template>
        </p-table>
      </div>
    </ls-card-atom>
  </div>
  <p-confirmDialog [style]="{ width: '450px' }" />
</div>
